import { useContext } from 'react';
import { SlugContext } from 'src/contexts/slug-context';

export function useSlug() {
  return useContext(SlugContext);
}

export default useSlug;
